import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './navTab.module.scss';
import { LocationDescriptor } from 'history';

interface Props {
  to: LocationDescriptor;
  children: ReactNode;
  exact?: boolean;
  className?: string;
  mobileView?: boolean;
}

const NavTab = ({ to, children, exact, className, mobileView = true }: Props) => {
  // helpers
  const getClasses = () => {
    let propClass = className ? ` ${className}` : ""; 
    let mobileClass = mobileView ? ` ${styles.navTabMobile}` : "";   
    return `${styles.navTab}${mobileClass}${propClass}`;
  }

  // render
  return (
    <NavLink
      to={to}
      className={getClasses()}
      exact={exact}
    >
      {children}
    </NavLink>
  )
}

export default NavTab;
